import React, { useEffect, useState } from 'react';
import { Article } from 'articles/types/Article';
import SavedArticle from './SavedArticle';
import { useTranslations } from '../../localization/useTranslations';

interface ArticlesProps {
  articles: Article[];
  isArticlesLoading: boolean;
  handleRemoveArticle: (id: string) => void;
}

const Articles: React.FC<ArticlesProps> = ({ articles, isArticlesLoading, handleRemoveArticle }) => {
  const [showEmptyState, setShowEmptyState] = useState(false);
  const translations = useTranslations();

  useEffect(() => {
    setShowEmptyState(articles.length === 0 || articles.every((article) => !article.isVisible));
  }, [articles]);

  if (isArticlesLoading) {
    return (
      <main className="saved-articles">
        <div className="container" style={{ height: '100vh' }}></div>
      </main>
    );
  }

  return (
    <>
      <main className="saved-articles">
        <div className="container">
          <div className="saved-articles__inner-container">
            {showEmptyState && (
              <div id="saved-articles-empty-state" className="empty-state">
                <p className="empty-message">{translations?.emptyStates?.noSavedArticles || 'No saved articles'}</p>
              </div>
            )}

            <div id="saved-articles" className="saved-articles__article-list">
              {articles
                .filter((article) => article.isVisible)
                .map((article) => (
                  <div key={article.id}>
                    <SavedArticle {...article} articleRemoved={() => handleRemoveArticle(article.id)} />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Articles;
